<div class="normal-modal-component">
  <div class="close-btn">
    <mat-icon (click)="closeClick()" svgIcon="close"></mat-icon>
  </div>
  <div mat-dialog-title>{{ data.title }}</div>
  <div mat-dialog-content>
    <span [innerHtml]="data.body"></span>
    <div class="spinner" style="margin-top: 35px;" *ngIf="loadingConfirmation">
      <app-spinner-loading></app-spinner-loading>
    </div>
  </div>
  <div mat-dialog-actions>
    <span class="cancel" (click)="closeClick()">
      {{ data?.btnCancelText ? data?.btnCancelText : 'Cancelar'}}
    </span>
    <button mat-raised-button color="primary02" class="sm" (click)="redirect()">
      {{ data?.btnConfirmText ? data?.btnConfirmText : 'Confirmar'}}
    </button>
  </div>
</div>
